import React, {useEffect, useState} from 'react'
import queryString from 'query-string'

const Info = props => {
    const [message, setMessage] = useState(false)

    useEffect(() => {
        const params = queryString.parse(props.location.search)
        setMessage(params.message)
    }, [])
    return <div>{message}</div>
}

export default Info
